import React, { useState, useEffect } from "react";
import "./MDContent.css";
import Modal from "react-modal";
import { MDData } from "./MDContentData.jsx";
import AOS from 'aos'
import 'aos/dist/aos.css';

function MDContent() {
  useEffect(() => {
    AOS.init({ duration: 800 })
  }, [])
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };

  return (
    <>
      <div className="md-container">
        <div className="md-wrap">
          <span className="tabs-bg"></span>
          {MDData.map((item) => {
            let video = item.mdVideo;
            return (
              <div className="md-row">
                <div className="md-box" onClick={() => handleOpenModal(video)} data-aos="zoom-in-up">
                  <img
                    src={item.mdImage}
                    alt={item.mdName + " profile pic"}
                    className="md-card-imgs"
                  />
                  <h3>{item.mdName}</h3>
                  <p className="md-project">{item.mdProject}</p>
                  <p className="md-market">{item.mdMarket}</p>
                </div>
                <Modal
                  isOpen={showModal && activeModal === video}
                  onRequestClose={() => setShowModal(false)}
                  // contentLabel="login Modal"
                  style={{
                    overlay: {
                      backgroundColor: "rgba(0, 0, 0, 0.75)",
                    },
                  }}
                >
                  <iframe
                    id="kmsembed-1_z06m2jc5"
                    width="100%"
                    height="85%"
                    src={item.mdVideo}
                    class="kmsembed"
                    allowfullscreen
                    webkitallowfullscreen
                    mozAllowFullScreen
                    allow="autoplay *; fullscreen *; encrypted-media *"
                    referrerPolicy="no-referrer-when-downgrade"
                    frameborder="0"
                    title="Testimonial"
                  ></iframe>
                  <h3>{item.mdName}</h3>
                  <p className="modal-project">{item.mdProject}</p>
                  <p className="modal-market">{item.mdMarket}</p>
                  <button
                    className="close closing-btn"
                    onClick={handleCloseModal}
                  >
                    <span>x</span> CLOSE
                  </button>
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default MDContent;
